import { createSearchParams, useNavigate } from 'react-router-dom';
import { DashboardAnalyticsDateRangeDays, rollingSubmittedDateRange } from './dashboardAnalytics';
import { useReloadRestore } from '../Applications/GuardianReport/utils/useReloadRestore';

// Root-tab index of the SBOM tab in the app detail report (see GuardianReport/tabs/RootTabs).
const SBOM_TAB_ROOT_INDEX = 3;

export function useDashboardNavigation(dateRangeDays: DashboardAnalyticsDateRangeDays) {
  const navigate = useNavigate();
  const { setAppDetailReportTabFocus } = useReloadRestore();

  const navigateToApplications = ({
    platform = 'all',
    appType = 'all',
    analysisStatus = 'all',
    categories = 'all',
    searchQuery = '',
    riskName = '',
    vendorName = '',
    cveId = '',
  }: {
    platform?: 'all' | 'android' | 'ios';
    appType?: string;
    analysisStatus?: string;
    categories?: string;
    searchQuery?: string;
    riskName?: string;
    vendorName?: string;
    cveId?: string;
  } = {}) => {
    const { startDate, endDate } = rollingSubmittedDateRange(dateRangeDays);
    const params: Record<string, string> = {
      platform,
      appType,
      startDate,
      endDate,
      analysisStatus,
      categories,
      searchQuery,
    };
    if (riskName) {
      params.riskName = riskName;
    }
    if (vendorName) {
      params.developerName = vendorName;
    }
    if (cveId) {
      params.cveId = cveId;
    }
    navigate({
      pathname: '/applications',
      search: createSearchParams(params).toString(),
    });
  };

  const navigateToAppReport = (analysisId: string, { focusSbomTab = false }: { focusSbomTab?: boolean } = {}) => {
    if (focusSbomTab) {
      // The report restores its active tab from this localStorage-backed store on mount.
      setAppDetailReportTabFocus({ root: SBOM_TAB_ROOT_INDEX, overview: 0, network: 0 });
    }
    navigate({
      pathname: '/applications/app-detail-report',
      search: createSearchParams({
        analysisId,
        backQParams: '',
      }).toString(),
    });
  };

  return { navigate, navigateToApplications, navigateToAppReport };
}
